(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-row.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-row.js');
"use strict";


const {
  useContext
} = React;
const {
  getOutcomeLabelsForEventType
} = svs.components.sport.tipsenShared;
const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  EngineProviderContext
} = svs.components.tipsen.engine;
const {
  useBranding
} = svs.components.tipsen.hooks;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  TableComponent
} = svs.components.tipsen.tipsinfo.tableComponents;
const {
  clx
} = svs.components.lbUtils;
const {
  isTextOrNumber
} = svs.components.lbUi.trend.utils;
const TipsinfoTableRow = _ref => {
  let {
    className,
    children,
    dataTestId = '',
    title,
    isGoalCount
  } = _ref;
  return React.createElement(TableComponent.Body.Row, {
    className: clx(className, 'tipsinfo-row', {
      'tipsinfo-row-fulltraff': isGoalCount
    }),
    dataTestId: dataTestId
  }, React.createElement(TableComponent.Body.Row.HeaderCell, null, title), children);
};
const TipsinfoRowStats = _ref2 => {
  let {
    children,
    sign = '',
    noValueSign = '-',
    className = ''
  } = _ref2;
  const classes = ['tipsinfo-row-stats-option'];
  if (className.length > 0) {
    classes.push(className);
  }
  return React.createElement("div", {
    className: "tipsinfo-row-stats tipsinfo-statistics-grid"
  }, React.Children.map(children, value => React.createElement("div", {
    className: classes.join(' ')
  }, isTextOrNumber(value) ? "".concat(value).concat(sign) : noValueSign)));
};
const TipsinfoRowText = _ref3 => {
  let {
    children,
    className
  } = _ref3;
  const classNames = ['tipsinfo-row-text'];
  className && classNames.push(className);
  return React.createElement("div", {
    className: classNames.join(' ')
  }, children || '-');
};
const TipsinfoRowAnalysisForecast = _ref4 => {
  let {
    children,
    className,
    title,
    dataTestid = ''
  } = _ref4;
  const {
    currentEngine
  } = useContext(EngineProviderContext);
  const draw = useCurrentDraw();
  const eventTypeId = currentEngine.outcomes.eventTypeId;
  const sportType = draw === null || draw === void 0 ? void 0 : draw.sportType;
  const outcomeLabels = getOutcomeLabelsForEventType(eventTypeId, sportType);
  const [productBranding] = useBranding();
  const isGoalCount = eventTypeId === EventTypeId.GOAL_COUNT;
  const isSelected = (outcomes, sign) => outcomes === null || outcomes === void 0 ? void 0 : outcomes.some(outcome => outcome.outcomeNumber === sign.toString());
  return React.createElement(TipsinfoTableRow, {
    className: clx(className, {
      'tipsinfo-row-fulltraff': isGoalCount
    }),
    "data-testid": dataTestid,
    scope: "row",
    title: title
  }, children && (outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map(outcomeLabel => React.createElement(TableComponent.Body.Row.ContentCell, {
    key: outcomeLabel.text
  }, React.createElement("div", {
    className: clx('btn-bet', 'btn-bet-200', className, {
      ["btn-bet-".concat(productBranding)]: productBranding,
      'btn-bet-selected': isSelected(children, outcomeLabel.sign)
    })
  }, React.createElement("span", {
    className: "btn-bet-label"
  }, outcomeLabel.text))))));
};
const TipsinfoRow = _ref5 => {
  let {
    className,
    children,
    dataTestId = '',
    title,
    isGoalCount
  } = _ref5;
  const classNames = isGoalCount ? ['tipsinfo-row-fulltraff'] : ['tipsinfo-row'];
  className && classNames.push(className);
  return React.createElement("div", {
    className: classNames.join(' '),
    "data-testid": dataTestId
  }, React.createElement("div", {
    className: "tipsinfo-row-title"
  }, title), children);
};
setGlobal('svs.components.tipsen.tipsinfo', {
  TipsinfoRow,
  TipsinfoRowAnalysisForecast,
  TipsinfoRowText,
  TipsinfoRowStats,
  TipsinfoTableRow
});

 })(window);